<template>
  <Toast position="top-right" class="fixed-top" style="z-index: 9999" />

  <div class="relative min-h-screen">
    
    <main class="transition-opacity duration-300">
      <RouterView />
    </main>

  </div>
</template>

<script setup>
import Toast from "primevue/toast";
import { RouterView } from "vue-router";

</script>

<style scoped>
.fade-loading-enter-active,
.fade-loading-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.fade-loading-enter-from,
.fade-loading-leave-to {
  opacity: 0;
}
</style>